import { Component, OnInit } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { PushToLiveService, DropdownOption, GetOptionsResponse, UploadExcelResponse, PushToLiveLog } from "./push-to-live.service";
import { AppConstants } from 'src/app/app.constants';

@Component({
  selector: 'app-push-to-live',
  templateUrl: './push-to-live.component.html',
  styleUrl: './push-to-live.component.scss'
})
export class PushToLiveComponent implements OnInit {

  options: DropdownOption[] = [];
  selectedOption: DropdownOption | null = null;
  selectedFile: File | null = null;
  isUploading: boolean = false;

  // Table data
  logs: PushToLiveLog[] = [];
  isLoadingLogs: boolean = false;

  constructor(
    private pushToLiveService: PushToLiveService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.getOptions();
    this.getLogs();
  }

  getOptions(): void {
    this.pushToLiveService.getOptions().subscribe({
      next: (response: GetOptionsResponse) => {
        this.options = response.options || [];
        // console.log('Options loaded:', this.options);
      },
      error: (error) => {
        console.error('Error fetching options:', error);
        this.toastr.error('Failed to load options', 'Error');
      }
    });
  }

  getLogs(): void {
    this.isLoadingLogs = true;
    this.pushToLiveService.getRecords().subscribe({
      next: (response: PushToLiveLog[]) => {
        this.logs = response || [];
        // console.log('Logs loaded:', this.logs);
      },
      error: (error) => {
        console.error('Error fetching logs:', error);
        this.toastr.error('Failed to load logs', 'Error');
        this.isLoadingLogs = false;
      },
      complete: () => {
        this.isLoadingLogs = false;
      }
    });
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];

    if (file) {
      // console.log('File details:', {
      //   name: file.name,
      //   type: file.type,
      //   size: file.size
      // });

      const fileExtension = file.name.split('.').pop()?.toLowerCase();

      if (!['xlsx', 'xls', 'csv'].includes(fileExtension || '')) {
        this.toastr.error('Please select a valid Excel (.xlsx, .xls) or CSV file', 'Invalid File');
        event.target.value = '';
        this.selectedFile = null;
        return;
      }

      this.selectedFile = file;
      // console.log('File selected:', file.name);
      this.toastr.info(`File selected: ${file.name}`, 'File Selected');
    }
  }

  uploadFile(): void {
    if (!this.selectedFile) {
      this.toastr.warning('Please select a file first', 'No File Selected');
      return;
    }

    if (!this.selectedOption) {
      this.toastr.warning('Please select a process type', 'No Option Selected');
      return;
    }

    this.isUploading = true;

    this.pushToLiveService.uploadExcel(this.selectedFile, this.selectedOption.value).subscribe({
      next: (response: UploadExcelResponse) => {
        // console.log('Upload response:', response);
        this.toastr.success(response.message, 'Success');
        this.toastr.info(`Log ID: ${response.log_id}`, 'Process Started');

        // Refresh logs after successful upload
        this.getLogs();
        this.clearForm();
      },
      error: (error) => {
        console.error('Upload error:', error);
        this.toastr.error(error?.error?.error || 'Failed to upload file', 'Error');
        this.isUploading = false;
      },
      complete: () => {
        this.isUploading = false;
      }
    });
  }

  refreshLogs(): void {
    this.getLogs();
  }

  downloadFile(filePath: string): void {
    // Construct the full URL for downloading
    const fileUrl = `${AppConstants.API_ENDPOINT1}${filePath}`;
    window.open(fileUrl, '_blank');
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'COMPLETED':
        return 'badge bg-success';
      case 'IN_PROCESS':
        return 'badge bg-warning';
      case 'ERROR':
        return 'badge bg-danger';
      default:
        return 'badge bg-secondary';
    }
  }

  clearForm(): void {
    this.selectedFile = null;
    this.selectedOption = null;

    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  clearFilter(): void {
    this.clearForm();
  }
}